import Observable from 'mixins/observable';

export default class extends Observable {
    constructor() {
        super();
        this.events = {};
        this.properties = {};
    }

    get(key) {
        return this.properties[key];
    }

    set(key, value) {
        if (this.properties[key] === value) {
          return;
        }
        this.properties[key] = value;
        this.fireEvent('changed');
    }

    remove(key) {
        delete this.properties[key];
        this.fireEvent('changed');
    }

    removeEvents() {
        this.events = {};
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/mixins/model.js